const Popout = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M6 6v12h12v-4.5h3V21H3V3h7.5v3H6Z" />
        <path d="M20.999 10.499 18.31 7.811l-6.75 6.75-2.122-2.122 6.75-6.75L13.5 3H21V10.5Z" />
    </svg>
);

export default Popout;
